import React from 'react';
import userBlock from '../../assets/user-block.svg';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const AccessDenied = () => {
    const { content } = useContentfulContext();

    return (
        <section className="h-fit">
            <div className="mx-auto flex flex-col md:flex-row items-center max-w-[75%] my-6">
                <div className="p-8 flex flex-col lg:w-1/2 justify-center items-start text-center m-auto my-9">
                    <div className="space-y-4 md:space-y-6 w-full">
                        <img src={userBlock} alt="Access Denied" className="h-16" />
                        <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900 md:text-3xl">
                            {content?.ACCESS_DENIED?.message}
                        </h1>
                        <div className="flex-col items-center">
                            <p className="font-light text-gray-500">
                                {content?.ACCESS_DENIED?.description}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AccessDenied;
